export default {
  PARTIAL_SETTLEMENT: 'Partial Settlement',
  FULL_SETTLEMENT: 'Full Settlement',
  PAY_IN_FULL: 'Pay In Full',
};
